/**
 * Leitura do corpo de erro das APIs.
 *
 * Os interceptores de resposta do railsApiService e do nestApiService fazem
 * `Promise.reject(response)` — rejeitam com o RESPONSE do axios, não com o
 * AxiosError. Então `error.response` NÃO existe no catch, e todo
 * `error.response.data.message` espalhado pelo app cai silenciosamente no
 * fallback: o usuário nunca vê o que o backend respondeu.
 *
 * Foi o que causou o ECS-665. O backend devolvia
 * `422 { code: 'profile_incomplete', message: 'complete seus dados...' }`, o
 * front lia `error.response.data.code` (undefined), não desviava para o
 * cadastro e mostrava "Tente novamente em instantes". O paciente pagava,
 * preenchia o questionário e ficava preso sem saber que faltavam RG, data de
 * nascimento e endereço.
 *
 * Lê os dois formatos de propósito: se algum dia os interceptores passarem a
 * rejeitar com o AxiosError, isto continua correto.
 */
export const apiErrorBody = (error: any): any => error?.response?.data ?? error?.data

export const apiErrorCode = (error: any): string | undefined => {
  const code = apiErrorBody(error)?.code
  return typeof code === 'string' ? code : undefined
}

/**
 * Mensagem exibível. O `message` nem sempre é texto — algumas respostas do
 * Rails devolvem um hash (`{ spree_user: '...' }`), e entregar um objeto para o
 * React como filho quebra a tela. Só texto passa; o resto vira o fallback.
 */
export const apiErrorMessage = (error: any, fallback: string): string => {
  const message = apiErrorBody(error)?.message
  return typeof message === 'string' && message.trim().length > 0 ? message : fallback
}
